/* jslint nomen: true */

'use strict';

var $ = require('jquery'),
    util = require('../../utils/util');

/**
 * @description Handler to show hints on variation selection
 */
var showHint = function ($el) {
    $el.addClass('reminder');
};

/**
 * @description Handler to hide hints on variation selection
 */
var hideHint = function ($el) {
    $el.removeClass('reminder');
};

/**
 * @description Handler to enable button when requirements fulfilled
 */
var enableButton = function ($target) {
    var $container = $target || $('.product-detail');
    var $addToCartButton = $container.find('.product-content-bottom button.add-to-cart-disabled');
    var $stickyAddToCartButton = $container.find('#add-to-cart-sticky');
    var $applePayBuyNow = $container.find('.product-content-bottom .apple-pay-hidden');
    var $addToWishlist = $container.find('.product-wishlist');
    var $quantityContainer = $container.find('.product-quantity');
    var $quickshop = $('.quick-shop');
    var $googlePayBtn = $('#google-pay-pdp-button');
    $addToWishlist.removeClass('disabled');
    $applePayBuyNow.removeClass('apple-pay-hidden');
    $quantityContainer.removeClass('disabled');
    $addToCartButton.removeClass('add-to-cart-disabled');
    $stickyAddToCartButton.removeClass('add-to-cart-disabled');
    $addToCartButton.attr('aria-disabled', false);
    $addToWishlist.find('.product-wishlist-link').prop('disabled', false);
    $addToCartButton.addClass('add-to-cart');
    $googlePayBtn.removeClass('google-pay-hidden');

    $('#add-to-cart-sticky').removeClass('add-to-cart-disabled');

    if (util.isMobile() && $quickshop.length) {
        $(window).scrollTop($(document).height());
    }
};

/**
 * @description Function to run evaluation, show hints and enable button
 */
var validateVariation = function (showHints, $target, noScroll, validateOutOfStock) {
    var $container = $target || $('#pdpMain');
    var $variationAttributes = $container.find('.product-variations').find('.attribute'),
        selectionCompleted = false,
        count = 0,
        headerHeight = $('.header-wrapper').outerHeight(),
        numberAttributes = $variationAttributes.length,
        isQuickView = $variationAttributes.closest('.pdp-main.quickview').length > 0,
        isQuickShop = $variationAttributes.closest('.product-content-top.quickshop-cockpit').length > 0,
        selAttrClass = '',
        unselAttrClass = '',
        reminderSelector = '.product-reminder-section span',
        isOutOfStock = $container.find('.availability-msg').find('.not-available-msg').length == 1,
        availableAttributes = ['color', 'width', 'size', 'refillSystem'];

    // skip check if variant is out of stock
    if (isOutOfStock && !validateOutOfStock) {
        return;
    }

    $variationAttributes.each(function () {
        var $availableOpt = $(this).find('.value').find('.selectable');
        if (validateOutOfStock) {
            $availableOpt = $(this).find('.value').find('.selectable, .unselectable');
        }
        var $sectionTit = $(this).find('.label').find('.label-text'),
            availableOptCount = $availableOpt.length,
            selectedOptCount = $(this).find('.value').find('.selected').length,
            attrID = $(this).data('attribute');

        if (availableOptCount > 0 && selectedOptCount === 0) {
            if (showHints) {
                showHint($sectionTit);
                showHint($availableOpt);
                unselAttrClass = unselAttrClass + '.' + attrID;
                availableAttributes.splice(availableAttributes.indexOf(attrID), 1);

                if ($(this).find('.selection').length > 0) {
                    showHint($(this).find('.selection'));
                    $container.find('.attribute-dropdown').addClass('red-error'); // #BSDRBRSH
                }
            }
        } else {
            hideHint($sectionTit);
            count += 1;
            selAttrClass = selAttrClass.length == 0 ? '.' + attrID : selAttrClass + ', .' + attrID;
            availableAttributes.splice(availableAttributes.indexOf(attrID), 1);
            if (count === numberAttributes) {
                // all attributes are chosen
                selectionCompleted = true;
            }
        }
    });

    if (
        !$variationAttributes.length &&
        $container.find('.product-content-bottom button.add-to-cart-disabled.button-cosmetics')
    ) {
        selectionCompleted = true;
    }

    reminderSelector += unselAttrClass;

    if (availableAttributes.length && selAttrClass.length > 0) {
        selAttrClass = selAttrClass + ', .' + availableAttributes.join(', .');
    } else if (availableAttributes.length) {
        selAttrClass = '.' + availableAttributes.join(', .');
    }

    if (selectionCompleted === true) {
        enableButton($container);
        $container.find(reminderSelector).addClass('reminder-hidden');
    } else if (showHints) {
        $container.find(reminderSelector).not(selAttrClass).removeClass('reminder-hidden');
        if (
            !noScroll &&
            !isQuickShop &&
            !isQuickView &&
            !util.elementInViewport($variationAttributes.get(0), headerHeight + 85)
        ) {
            util.scrollBrowser($container.find('.product-variations').offset().top - headerHeight - 10);
        }
    }
};

/**
 * @description Set handler and set add-to-cart-button state
 */
var initVariantValidation = function () {
    const $productDetailCntr = $('.product-detail:not(.product-set-detail)');
    validateVariation(false);

    $productDetailCntr.on('click', '.add-to-cart-disabled', function (e) {
        e.preventDefault();
        const header = $('#header_1774');
        const headScrollCssValue = parseFloat(header.css('--header-scroll-val'));
        validateVariation(true, null, true); // Validate first with noScroll true - fix for BSDDEV-11120
        let targetOffset = $('.product-detail').find('.product-variations').offset().top - 85;
        if ($('.pdp-1774').length) {
            targetOffset = $('.product-detail').find('.reminder').first().offset().top - headScrollCssValue;
        }
        util.scrollBrowser(targetOffset);
    });

    $productDetailCntr.on('click', '.pdp-btn-container .btn-bopis', function (e) {
        e.preventDefault();
        validateVariation(true);
    });

    $productDetailCntr.on('click', '.store-avability-validate-variation', function (e) {
        e.preventDefault();
        validateVariation(true, null, true, true);
        return false;
    });

    $('.store-availability-find-stores-disabled').on('click', function (e) {
        e.preventDefault();
        validateVariation(true, $('.ocd-flyin.fly-in-store-inventory-dialog'), true, true);
        return false;
    });

    $productDetailCntr.on('click', '.product-wishlist.disabled', function (e) {
        e.preventDefault();
        validateVariation(true);
    });
};

/**
 * @description Set handler and set add-to-cart-button state
 */
var initSetProductValidation = function () {
    const $setItems = $('.product-set-item');
    $setItems.each(function () {
        validateVariation(false, $(this));
    });
    $('.product-set-detail').on('click', '#add-to-cart-sticky', function (e) {
        e.preventDefault();
        $setItems.each(function () {
            validateVariation(true, $(this), true);
        });
    });
    $('.product-set-detail').on('click', '.add-to-cart-disabled:not(#add-all-to-cart)', function (e) {
        e.preventDefault();
        validateVariation(true, $(e.target).closest('.product-set-item'));
    });
    $('.product-set-detail').on('click', '.product-wishlist.disabled', function (e) {
        e.preventDefault();
        validateVariation(true, $(e.target).closest('.product-set-item'));
    });
    $('.product-set-detail').on('click', '#add-all-to-cart.add-to-cart-disabled', function (e) {
        e.preventDefault();
        $setItems.each(function () {
            validateVariation(true, $(this));
        });
    });
};

var initQuickShopValidation = function () {
    var $quickShop = $('.quick-shop');
    validateVariation(false, $quickShop, false, true);
    $quickShop.on('click', '.add-to-cart-disabled, .product-wishlist.disabled', function (e) {
        e.preventDefault();
        validateVariation(true, $quickShop, false, true);
    });
};

var initQuickShopSetValidation = function () {
    var $quickShop = $('.quick-shop');
    var $setItems = $quickShop.find('.product-set-item');

    $setItems.each(function () {
        validateVariation(false, $(this), false, true);
    });

    $quickShop.on('click', '.add-to-cart-disabled, .product-wishlist.disabled', function (e) {
        e.preventDefault();

        $setItems.each(function () {
            validateVariation(true, $(this), false, true);
        });
    });
};

var variationValidation = {
    init: initVariantValidation,
    validate: function () {
        validateVariation(true);
    },
    initSetProductValidation: initSetProductValidation,
    validateSetProduct: function (showHints, $target) {
        validateVariation(showHints, $target);
    },
    initQuickShopValidation: initQuickShopValidation,
    initQuickShopSetValidation: initQuickShopSetValidation
};

module.exports = variationValidation;
